/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetChildrenQueryResponse, HierarchiesControllerGetChildrenPathParams, HierarchiesControllerGetChildrenQueryParams, HierarchiesControllerGetChildren401, HierarchiesControllerGetChildren403 } from "../../models/hierarchiesController/HierarchiesControllerGetChildren";

function getHierarchiesControllerGetChildrenUrl(scopeId: HierarchiesControllerGetChildrenPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/children` as const }  
  return res
}

/**
 * @description Retrieve immediate child scopes of a given scope. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get child scopes
 * {@link /api/v1/hierarchies/:scopeId/children}
 */
export async function hierarchiesControllerGetChildren(scopeId: HierarchiesControllerGetChildrenPathParams["scopeId"], params?: HierarchiesControllerGetChildrenQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetChildrenQueryResponse, ResponseErrorConfig<HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403>, unknown>({ method : "GET", url : getHierarchiesControllerGetChildrenUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}